/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { GET_TASK_COMPLETION_STATUS, TASK_COMPLETION_STATUS_RESPONSE } = constants.GetTaskStatusConstants;

export default {
    GET_TASK_COMPLETION_STATUS,
    TASK_COMPLETION_STATUS_RESPONSE,

  requestTaskStatusData: payload => ({
    type: GET_TASK_COMPLETION_STATUS,
    payload
  }),
  taskStatusDataReceived: () => ({
    type: TASK_COMPLETION_STATUS_RESPONSE
  }),
};
